export default [{
    1: 'Draft',
    2: 'Published',
    3: 'Archived'
  }];